export const purchaseProcess = [
  {
    number: "01",
    title: "電話査定：3分",
    description: "メーカー・車種・年式・状態などをお電話で伺います。",
    kind: "appraisal",
  },
  {
    number: "02",
    title: "買取金額をご案内・決定",
    description: "電話査定の中で買取金額をご案内し、内容をご確認いただきます。",
    kind: "decision",
  },
  {
    number: "03",
    title: "引き取り日時を調整：最短当日",
    description: "地域・受付状況に応じて、引き取り日時を調整します。",
    kind: "schedule",
  },
  {
    number: "04",
    title: "車両確認・積載：約5分",
    description: "車両確認と積載を行います。車両状態・積載状況により前後します。",
    kind: "onsite",
  },
  {
    number: "05",
    title: "現金でお支払い",
    description: "引き取り時に、買取金額を現金でお支払いします。",
    kind: "payment",
  },
  {
    number: "06",
    title: "抹消手続き：無料",
    description: "引き取り後の抹消手続きを無料で対応します。",
    kind: "paperwork",
  },
] as const;
